import update from 'immutability-helper'
import React, {useContext} from 'react'
import {useHistory, Link} from 'react-router-dom'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import MoreVertIcon from '@mui/icons-material/MoreVert'
import Menu from '@mui/material/Menu'
import MenuItem from '@mui/material/MenuItem'
import DialogContentText from '@mui/material/DialogContentText'

import TextInput from 'components/text-input'
import Dialog from 'components/responsive-fullscreen-dialog'
import Select from 'components/quiz/components/SelectDirectory'
import create from 'helpers/command'
import {TeacherContext} from 'teacher/context'

export default function AssessmentRowSettings ({assessment, classes}) {
  const context = useContext(TeacherContext)
  const history = useHistory()
  const {translate} = context
  const [anchorEl, setAnchorEl] = React.useState(null)
  const [deleteOpened, openDeleteAssessment] = React.useState(false)
  const [moveToDirectoryOpened, openMoveToDirectory] = React.useState(false)
  const [pdfOpened, openPdf] = React.useState(false)
  const [directory, setDirectory]  = React.useState(assessment.directory || "")


  const openRowSettingsMenu = (e) => {
    setAnchorEl(e.currentTarget)
  }

  const closeRowSettingsMenu = (e, reason) => {
    setDirectory(assessment.directory || "")
    setAnchorEl(null)
  }

  function handleOpenDelete() {
    closeRowSettingsMenu()
    openDeleteAssessment(true)
  }

  async function handleDelete(confirmed) {
    openDeleteAssessment(false)
    if (confirmed) {
      const [deletedId] = await create('quiz', 'deleteAssessment')({id: assessment.id})
      if (deletedId == assessment.id) {
        if (context.query.id) context.navigate({}, undefined, {query: {...context.query, id: undefined}})
        else context.setState({quizAssessmentCalls: context.quizAssessmentCalls + 1})
      }
    }
  }

  async function handleShare () {
    closeRowSettingsMenu()
    const shared = !assessment.shared
    const [sharedId] = await create('quiz', 'shareAssessment')({id: assessment.id, shared})
    if (sharedId == assessment.id) {
      const index = context.quizAssessments.findIndex(({id}) => id == sharedId)
      if (index >= 0) {
        const quizAssessments = update(context.quizAssessments, {[index]: {shared: {$set: shared}}})
        context.setState({quizAssessments})
      }
    }
  }

  function handleOpenMoveToDirectory() {
    closeRowSettingsMenu()
    openMoveToDirectory(true)
  }

  async function handleMoveToDirectory() {
    openMoveToDirectory(false)
    const [movedId] = await create('quiz', 'moveAssessment')({id: assessment.id, directory})
    if (movedId == assessment.id) {
      context.setState({quizAssessmentCalls: context.quizAssessmentCalls + 1})
    }
  }

  function handleCloseMoveToDirectory() {
    openMoveToDirectory(false)
  }

  async function handlePrintBlankAssessmentPdf () {
    closeRowSettingsMenu()
    await create('quiz', 'startTestAssessment')({id: assessment.id})
    context.updateState({quizBlankAssessmentForPdfId: {$set: assessment.id}})
  }

  return (
    <Box className={classes.moreSettings}>
      <Box className={classes.moreSettingsButton} onClick={openRowSettingsMenu}>
        <MoreVertIcon />
      </Box>
        <Menu
          id="settings-menu"
          anchorEl={anchorEl}
          keepMounted
          open={Boolean(anchorEl)}
          onClose={closeRowSettingsMenu}
        >
          <MenuItem onClick={handleShare}>{translate(assessment.shared ? 'unshare' : 'share')}</MenuItem>
          <MenuItem onClick={handleOpenMoveToDirectory}>{translate('move-to-directory')}</MenuItem>
          <MenuItem onClick={handlePrintBlankAssessmentPdf}>{translate('blank-assessment-pdf')}</MenuItem>
          <MenuItem onClick={handleOpenDelete}>{translate('delete')}</MenuItem>
        </Menu>
      <Dialog
        open={moveToDirectoryOpened}
        close={handleCloseMoveToDirectory}
        confirm={<Button variant="contained" color="primary" onClick={handleMoveToDirectory}>{translate('move')}</Button>}
        cancel={<Button variant="contained" color="secondary" onClick={handleCloseMoveToDirectory}>{translate('cancel')}</Button>}
        title={translate('move-assessment-message', assessment)}
      >
          <Select
            controlFullWidth
            controlVariant="outlined"
            id="directory"
            caption={translate('directory')}
            selectValue={directory || ''}
            selectOnChange={e => setDirectory(e.target.value == "" ? undefined : e.target.value)}
            context={context}
          />
      </Dialog>
      <Dialog
        open={deleteOpened}
        close={handleDelete}
        confirm={<Button variant="contained" color="primary" onClick={() => handleDelete(true)}>{translate('delete')}</Button>}
        cancel={<Button variant="contained" color="secondary" onClick={() => handleDelete()}>{translate('cancel')}</Button>}
        title={translate('confirm_delete_item')}
      >
        <DialogContentText>
          {translate('delete-assessment-message', assessment)}
        </DialogContentText>
      </Dialog>
    </Box>
  )
}
